import { fetchRequest } from "@providers/conect";

const getAllEspecialidadesApi = async () => {
  try {
    const url = `especialidades/all`;
    const response = await fetchRequest(url, {
      method: "GET"
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const viewEspecialidadesApi = async (data) => {
  try {
    const url = `especialidades/view`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const viewEspecialidadesGroupApi = async (data) => {
  try {
    const url = `especialidades/allgroup`;
    const response = await fetchRequest(url, {
      method: "GET"
    });
    return response;
  } catch (error) {
    throw error;
  }  
};

export {
  getAllEspecialidadesApi,
  viewEspecialidadesApi,
  viewEspecialidadesGroupApi
};